import React from 'react';
import AdSlot from '../components/AdSlot';

export default function Results({ results, profile, onRematch, onMenu }) {
  if (!results) return null;
  const win = results.rank === 1;
  const stats = [
    { label: 'Snacks Collected', value: results.snacks, icon: '🍿' },
    { label: 'Successful Thefts', value: results.thefts, icon: '💥' },
    { label: 'Best Combo', value: 'x' + (results.combo || 0), icon: '🔥' },
    { label: 'Times Caught', value: results.caught, icon: '🚨' },
    { label: 'Best Smash', value: results.bestSmash + ' drop', icon: '⭐' },
    { label: 'Coins Earned', value: '+' + results.coins, icon: '🪙' },
  ];

  return (
    <div className="so-menu" data-testid="results-screen">
      <div className="so-menu-bg" />
      <div className="so-results">
        <div className={'so-results-banner' + (win ? ' win' : '')}>
          {win ? '🏆 VICTORY!' : 'MATCH OVER'}
        </div>

        <div className="so-results-score">
          <div className="so-results-rank" data-testid="results-rank">RANK #{results.rank}<small>of {results.total}</small></div>
          <div className="so-results-pts" data-testid="results-score">{results.score.toLocaleString()}<span>points</span></div>
        </div>

        <div className="so-results-stats">
          {stats.map((s) => (
            <div key={s.label} className="so-rstat" data-testid={'rstat-' + s.label.split(' ')[0].toLowerCase()}>
              <span className="so-rstat-icon">{s.icon}</span>
              <b>{s.value}</b>
              <small>{s.label}</small>
            </div>
          ))}
        </div>

        <div className="so-results-board" data-testid="results-leaderboard">
          <div className="so-lb-title">FINAL STANDINGS</div>
          {results.leaderboard.map((p, i) => (
            <div key={p.id} className={'so-board-row' + (p.me ? ' me' : '') + (i < 3 ? ' top' : '')}>
              <span className="so-board-rank">{['🥇', '🥈', '🥉'][i] || i + 1}</span>
              <span className="so-board-name">{p.name}{p.me ? ' (you)' : ''}</span>
              <span className="so-board-score">{p.score}</span>
            </div>
          ))}
        </div>

        <div className="so-results-actions">
          <button className="so-btn-play" onClick={onRematch} data-testid="results-rematch">🔁 Rematch</button>
          <button className="so-btn-ghost" onClick={onMenu} data-testid="results-menu">Main Menu</button>
        </div>

        <AdSlot label="Sponsored" testid="adsense-results-slot" style={{ marginTop: 16 }} />
      </div>
    </div>
  );
}
